import { TypeSerializerUtils } from '../utils/type-serializer.util';

export const PagedResponseConverter = {
  deserialize: (data: any, object: any): any => {
    const key = data.__typename.charAt(0).toLowerCase() + data.__typename.slice(1);
    object[key + 'MetaData'] = data.metadata;
    return TypeSerializerUtils.deserializeWithoutType(data.data);
  }
};
